<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <van-popup class="eqpopup" v-model="eq_show" @click-overlay="closePop()">
      <div class="poptitle">长按识别汽车时间motortime小程序</div>

      <img class="wechateq" :src="img.wechateq">
    </van-popup>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { Tabbar, TabbarItem,Popup } from "vant";
  export default {
    data () {
      return {
        tabbar: {
          home: require('./assets/img/icon/index.png'),
          home_active: require('./assets/img/icon/index_select.png'),
          bbs: require('./assets/img/icon/groups.png'),
          bbs_active: require('./assets/img/icon/groups_select.png'),
          ask: require('./assets/img/icon/question.png'),
          ask_active: require('./assets/img/icon/question_select.png'),
          shop: require('./assets/img/icon/shop.png'),
          shop_active: require('./assets/img/icon/shop_select.png'),
          my: require('./assets/img/icon/my.png'),
          my_active: require('./assets/img/icon/my_select.png'),
        },
        img:{
          wechateq:require('./assets/img/wechateq.png')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source,
        active: state => state.param.active,
        is_show: state => state.param.is_show,
        eq_show: state => state.param.eq_show
      })
    },
    created () {

      var token=localStorage.getItem('token')
      if(this.source == 1) {
        if(localStorage.getItem('token')){
          this.token=true
        }else{
            // this.getAuthorization.getAuthorization();
          }
        }
//         let firstOpenTime = localStorage.getItem('firstOpenTime');  

// // 获取当前时间  
// let now = new Date().getTime();  

// // 如果第一次打开应用的时间不存在 
// if (!firstOpenTime) {  
  
//   // 记录当前时间作为第一次打开应用的时间  
//   firstOpenTime = now;  
//   localStorage.setItem('firstOpenTime', firstOpenTime);  
// }else{
//   //或已超过5天 
//   if(now - firstOpenTime > 5 * 24 * 60 * 60 * 1000){
//     // 清除缓存  
//     window.location.reload(true);
//     localStorage.clear(); 
//     firstOpenTime = now;  
//     localStorage.setItem('firstOpenTime', firstOpenTime);  
//   }
// }

},
watch:{
  '$route'() {
    console.log('app==')
  }
},
methods: {

  tab (e) {
    this.$store.commit('param/active', e)
    this.$router.push({name: e})
  },
  closePop(){
    this.$store.commit('param/eqshow', false)
  },
},
components: {
  [Tabbar.name]: Tabbar,
  [TabbarItem.name]: TabbarItem,
  [Popup.name]:Popup,
}
};
</script>

<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
  background-color: #fff;
  color: #3A3A3A;

  .van-tabbar {
    border-top: 1px solid #F0F0F0;
    box-shadow: 0 0 5px #F0F0F0;
  }
  .van-nav-bar {

    .van-nav-bar__title {
      font-size: 17px;
    }
    .van-icon {
      color: #3A3A3A;
    }
  }
  .list-loading {
    padding: 10px 0;
    color: #9A9A9A;
    font-size: 12px;
    text-align: center;
    line-height: 24px;

    img {
      width: 31px;
      display: block;
      margin: 0 auto;
    }
  }
  .text-c{
    text-align: center;
  }
  .text-r{
    text-align: right
  }
  .text-l{
    text-align: left;
  }
  .f-l{
    float: left
  }
  .f-r{
    float: right
  }
  .f-11{
    font-size: 11px;
  }
  .f-12{
    font-size: 12px;
  }
  .f-13{
    font-size: 13px;
  }
  .f-14{
    font-size: 14px;
  }
  .f-15{
    font-size: 15px;
  }
  .f-16{
    font-size: 16px;
  }
  .f-17{
    font-size: 17px;
  }
  .f-18{
    font-size: 18px;
  }
  .f-w{
    font-weight: bold;
  }
  .mt-5{
    margin-top: 5px;
  }
  .mt-10{
    margin-top: 10px;
  }
  .mt-15{
    margin-top: 15px;
  }
  .mt-20{
    margin-top: 20px;
  }
  .mt-25{
    margin-top: 25px;
  }
  .mt-30{
    margin-top: 30px;
  }
  .mt-40{
    margin-top: 40px;
  }
  .mt-50{
    margin-top: 50px;
  }
  .mb-5{
    margin-bottom: 5px;
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .mb-15{
    margin-bottom: 15px;
  }
  .mb-20{
    margin-bottom: 20px;
  }
  .mb-25{
    margin-bottom: 25px;
  }
  .mb-30{
    margin-bottom: 30px;
  }
  .mb-40{
    margin-bottom: 40px;
  }
  .mb-50{
    margin-bottom: 50px;
  }
  .ml-5{
    margin-left: 5px;
  }
  .ml-10{
    margin-left: 10px;
  }
  .ml-15{
    margin-left: 15px;
  }
  .ml-20{
    margin-left: 20px;
  }
  .ml-25{
    margin-left: 25px;
  }
  .mr-5{
    margin-right: 5px;
  }
  .mr-10{
    margin-right: 10px;
  }
  .mr-15{
    margin-right: 15px;
  }
  .mr-20{
    margin-right: 20px;
  }
  .mr-25{
    margin-right: 25px;
  }
  .mr-30{
    margin-right: 30px;
  }
  .mr-40{
    margin-right: 40px;
  }
  .ellipsis{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsis-2 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ellipsis-3 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ellipsis-4 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .c-black {
    color: #3a3a3a;
  }
  .c-gray {
    color: #9a9a9a;
  }
  .c-org{
    color: #F6AB00;
  }
  .c-blue {
    color: #33a1ff;
  }
  .c-red{
    color: #EF3535;
  }
  .c-white{
    color: #fff;
  }
  .c-conten{
    color: #728fc4;
  }
  .c-member{
    color: #605c6b;
  }
  .mb-no {
    margin-bottom: 0;
  }
  .nodata{
    margin-top: 20%;
    font-size: 14px;
    color: #9a9a9a;
    text-align: center;
  }
  .postbottom{
    position: fixed;
    bottom:-1px;
    width: 100%;
    font-size: 12px;
    background-color: #fff;
    border-top: 1px solid #f8f8f8;
    .van-field__control{
      padding:5px;
      background-color:#f8f8f8;
    }
    .van-cell{
      padding: 10px;
    }
    .botright{
      padding: 18px 0 0 10px;
      .binbox{
        .binpic{
          width: 15px;
          height: 15px;
          margin-right: 3px;
          vertical-align: middle;
        }
        .num{
          font-size: 12px;
          color: #9A9A9A;
          vertical-align: middle;
        }
      }
    }
    .van-col--5{
      padding-top: 12px;
      .van-button--small{
        padding: 0 20px;
      }
    }
  }
  .postoverlay{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 92%;
    background-color: rgba(0,0,0,0);
  }
  .totopbox{
    position: fixed;
    bottom: 80px;
    right: 20px;

  }
  .totop{
    width: 60px;
    height: 60px;
  }
  .poptitle{
    padding: 25px;
    font-size: 14px;
    font-weight: bold;
    background-color: #F6AB00;
    color: #fff;
  }
  .wechateq{
    width: 200px;
    height: 200px;
    padding: 30px;
  }
  .eqpopup{
    width: 80%;
    height: 55%;
    text-align: center;
    border-radius: 2px;
  }
  .discenter{
    align-items: center;
    display: flex;
  }
  .member_car{
    width: 13px;
    height: 13px;
    margin-right: 3px;
    vertical-align: middle;
  }
  .mt-5{
    margin-top: 5px;
  }
  .display_flex{
    display: flex;
    align-items:center;
  }
  .userpop{
    font-size: 14px;
    padding: 25px 20px;
    width: 70%;
    border-radius: 3px;
    .sourcepop{
      margin-bottom: 40px;
    }
  }
    // 弹窗样式
    .pd-30{
      padding:30px;
    }
    .wask_page{
      width: 100%;
      height: 100%;
      position:fixed;
      top: 0;
      bottom:0;
      background-color:rgba(0, 0, 0, 0.7);
      z-index: 1000;
      overflow-y:hidden;
    }
    .wask_qrcode{
      width: 240px;
      height: 300px;
      position: fixed;
      top: 30%;
      left: 19%;
      z-index: 1001;
      border-radius: 4px;
      text-align: center;
      color: #000000;
      font-size: 14px;
      background-size: 240px 300px;
    }
    .wechatqr{
      width: 120px;
      height: 120px;
      margin-top: 50px;
      border-radius: 300px;
    }
    .more_comm{
      width: 100%;
      height: 50px;
      background-size: 100% 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #000000;
      border-radius:4px;
    }
  }
  .pageTitle{
    font-size: 16px;
    color: #000000;
    padding:20px 15px;
    font-weight: 500;
    border-bottom:1px solid #EEEEEE;
    background-color: #fff;
    z-index: 1000;
  }
  .nocopy{
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .home_icon{
    width: 18px;
    height: 18px;
  }
  .back_icon{
    width: 14px;
    height: 14px;
  }
  .agreement_title {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  .agreement_content {
    margin-top: 10px;
    font-size: 14px;
  }
</style>
